import { render } from "./productDetail.vue?vue&type=template&id=60c0a94b&scoped=true"
import script from "./productDetail.vue?vue&type=script&lang=js"
export * from "./productDetail.vue?vue&type=script&lang=js"

import "./productDetail.vue?vue&type=style&index=0&id=60c0a94b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60c0a94b"]])

export default __exports__